import { render, staticRenderFns } from "./useridlock.vue?vue&type=template&id=5a91925a&scoped=true"
import script from "./useridlock.vue?vue&type=script&lang=js"
export * from "./useridlock.vue?vue&type=script&lang=js"
import style0 from "./useridlock.vue?vue&type=style&index=0&id=5a91925a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91925a",
  null
  
)

export default component.exports